import { render, staticRenderFns } from "./warning-config.vue?vue&type=template&id=795d02a8&scoped=true&"
import script from "./warning-config.vue?vue&type=script&lang=js&"
export * from "./warning-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795d02a8",
  null
  
)

export default component.exports